import React from 'react';
import queryString from 'query-string';
import { Form, Progress } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from '../../containers/I18nProvider';
import { WithCaptcha } from '../../containers/captcha';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'uplay';
    this.ref = React.createRef();
    this.state = {
      select: '',
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });



    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value,
        operador: this.state.select
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Usuario o Contraseña Incorrectos, intente nuevamente.';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div ref={this.ref}>
          <Form onSubmit={event => this.onSubmit(event)} className='uplay-form'>
            <input
              className='color-input'
              disabled={this.state.onLogin}
              placeholder={translate('PlaceholderUserName')}
              ref={(ref) => {
                this.usernameInput = ref;
              }
              }
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              name="username"
            />
            <input
              className='color-input'
              required={true}
              disabled={this.state.onLogin}
              placeholder={translate('Contraseña')}
              ref={(ref) => {
                this.passwordInput = ref;
              }
              }
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              name="password"
            />

            <select value={this.state.select} onChange={(e) => this.setState({ select: e.target.value })}>
              <option>Seleccione Operador</option>
              <option value="6">Cable Dos Mil Tacuarembó</option>
              <option value="7">Cable Visión 33</option>
              <option value="8">Cable Vision Salto</option>
              <option value="5">Del Faro TV Cable</option>
              <option value="4">Melo TV Cable</option>
              <option value="10">Minas Cable Visión</option>
              <option value="11">Multiseñal</option>
              <option value="2">Telecable Paysandú</option>
              <option value="12">Video Cable Rivera</option>
              <option value="13">Yi Visión Durazno</option>
            </select>
            <div className="buttons">
              {!this.state.onLogin ?
                <button
                  block={!this.parameters.failureRedirect}
                  tabIndex={1}
                  type="submit"
                  name="submit"
                  disabled={!this.props.turnstileSuccess}
                >
                  {translate('Ingresar')}
                </button> :
                <Progress animated color="primary" value={100} className='uplay-progress' />}
            </div>
            <div className='uplay-error-container'>
              <strong className='uplay-error-msg'>{this.state.error.message} </strong>
            </div>
            <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
          </Form>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
